import { post } from '../index';

const editProfile = (body) => {
  return post(`/users/profile/${body.id}`, body.payload);
};

export { editProfile };
